/**
 * When the text is not dirty, return null so the prop would not be include within the request body of GWS API
 */
export default function getModifiedField(newText: string, originalText: string): string | null {
    if (newText === originalText) {
        return null;
    }

    return newText;
}
